module.exports = __webpack_public_path__ + "static/img/special-day-tablet.2c3862f.webp";